export const MESSAGE_BOX_TIMEOUT = 7000

export const DEFAULT_SNACKBAR_TIMEOUT = 6000

export const PASSWORD_RESET_SUCCESS_TIMEOUT = 5000

export const REACTIONS_TIMEOUT = 2000
